export default __webpack_public_path__ + "static/media/spring.200da33f.png";